import { render, staticRenderFns } from "./ComplianceScans.vue?vue&type=template&id=0f33a45b&scoped=true&"
import script from "./ComplianceScans.vue?vue&type=script&lang=js&"
export * from "./ComplianceScans.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceScans.vue?vue&type=style&index=0&id=0f33a45b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f33a45b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f33a45b')) {
      api.createRecord('0f33a45b', component.options)
    } else {
      api.reload('0f33a45b', component.options)
    }
    module.hot.accept("./ComplianceScans.vue?vue&type=template&id=0f33a45b&scoped=true&", function () {
      api.rerender('0f33a45b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/ComplianceScans.vue"
export default component.exports